export default __webpack_public_path__ + "static/media/payment_successful.09a4d1a2.png";